import SitesDataGrid from './SitesDataGrid';

export default SitesDataGrid;
